import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Nav from '../components/Nav';
import PressKit from '../components/PressKit';
import Footer from '../components/Footer';
import { IMAGES } from '../data/mock';

const HOME_TITLE =
  'ASH — The Witch Trials of Drudenhaus | Best Immersive Halloween Theatre in London 2026';

export default function PressPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Press & Media — ASH | The Witch Trials of Drudenhaus';
    return () => {
      document.title = HOME_TITLE;
    };
  }, []);

  return (
    <>
      <Nav />
      <main data-testid="press-page">
        <section className="relative pt-32 md:pt-40 pb-16 md:pb-20 px-6 md:px-10 overflow-hidden">
          <div
            aria-hidden="true"
            className="absolute inset-0 bg-cover bg-center opacity-30"
            style={{ backgroundImage: `url(${IMAGES.trial})` }}
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#0a0705] via-[#0a0705]/70 to-[#0a0705]" />
          <div className="relative max-w-5xl mx-auto">
            <Link
              to="/"
              data-testid="press-back-link"
              className="inline-flex items-center gap-2 text-[10px] tracking-[0.35em] font-fell-sc uppercase text-[#a89880] hover:text-[#e8dcc0] transition-colors"
            >
              <ArrowLeft className="w-3.5 h-3.5" />
              Back to the show
            </Link>
            <h1 className="mt-8 font-display text-4xl sm:text-5xl lg:text-6xl text-[#f4e8ce] lowercase leading-none">
              press & media
            </h1>
            <p className="mt-6 font-fell italic text-base md:text-lg text-[#d9c8a3] max-w-2xl leading-relaxed">
              Everything editors, listings sites and ticketing partners need for
              ASH — The Witch Trials of Drudenhaus: press release, hi-res
              photography, every image crop, ready-made blurbs and a press
              contact.
            </p>
          </div>
        </section>
        <PressKit />
      </main>
      <Footer />
    </>
  );
}
